module.exports = __webpack_public_path__ + "img/highvoltage.ac595873.svg";